import { sessionUser } from 'utility/sessionStorageHelper';

export const stopGoURL = endpoint => {
  const { customerId, userId } = sessionUser.getLoggedInUser().getId();
  return `stopgosvc/v0/cust/${customerId}/user/${userId}/${endpoint}`;
};
